import $ from 'jquery';
import _ from 'lodash';
import 'selectric';

export default {
  init() {
    // console.log('common');
  },
  finalize() {
    SiteNav.init();
    SiteForms.init();
    LoadMore.init();
    SelectBoxes.init();
  },
};

var SelectBoxes = ( () => {
  var self = {};

  const options = {
    arrowButtonMarkup: '<b class="button"></b>'
  }

  self.init = () => {
    $('select').each( (idx, el) => {
      var $el = $(el);

      /* Special case, ignore states dropdown which only appears if specific countries are chosen */
      if($el.hasClass('mepr-states-dropdown') && !$el.is(':visible'))
        return;

      /* Selectrify visible select */
      $(el).selectric(options);

      /* Add a special case for registration form where country selection hide/show the state select */
      if($el.hasClass('mepr-countries-dropdown')) {
        /* We need to catch both the native select change and the selectric event in order to account for mobile and desktop modes */
        $el.on('selectric-change', self.initStateDD);
        $el.on('change', self.initStateDD);
      }

      /* This is used to bubble up the invalid class on select to the selectric wrapper to properly display errors */
      var config = { attributes: true };
      var observer = new MutationObserver(self.selectObserverCallback);
      observer.observe(el, config);
    });
  };

  self.selectObserverCallback = (mutationsList, observer) => {
    for(var mutation of mutationsList) {
      var $target = $(mutation.target),
          $selectricParent = $target.parents('.selectric-wrapper').first();

      if (mutation.type == 'attributes') {
        $selectricParent.toggleClass('invalid', $target.hasClass('invalid'));
      }
    }
  };

  self.initStateDD = () => {
    var $state = $("select.mepr-states-dropdown");

    /* If the select is visible, let's selectrify it */
    if($state.is(':visible')) {
      /* Reset */
      $state.selectric('destroy');
      $state.selectric(options);
    }
    /* Otherwise, if it's not visible but already instantiated, let's destroy it */
    else if($state.parents('.selectric-wrapper').length > 0) {
      $state.selectric('destroy');
    }
  };

  return self;
})();

var LoadMore = ( () => {
  var self = {};

  const $loadMore = $("a.load-more"),
        $posts = $("#posts");

  self.init = () => {
    $loadMore.click(self.loadMore);
  };

  self.loadMore = (e) => {
    e.stopPropagation();

    var perPage = $(e.target).data('per-page'),
        page = $(e.target).data('page');

    console.log("paginate", perPage, page);

    $.ajax({
      url: ajaxpagination.ajaxurl,
      type: 'post',
      data: {
        'action': 'get_blog_posts',
        'per-page': perPage,
        'page': page + 1,
        'query_vars': ajaxpagination.query_vars
      },
      success: function(html) {
        if(html != '') {
          $(e.target).data('page', page + 1);
          if($(e.target).data('page') == $(e.target).data('max-page')) {
            $(e.target).remove();
          }
          $posts.append(html);
        }
        else {
          $(e.target).remove();
        }
      }
    })
    return false;

  };

  return self;
})();

var SiteForms = ( () => {
  var self = {};

  self.init = () => {
    $('form input').bind('input', (e) => {
      var $input = $(e.target);
      self.updateInput($input);
    });
    $('form input:not([type=hidden]):not([type=submit])').each( (idx, el) => {
      self.updateInput($(el));
    });
  };

  self.updateInput = ($input) => {
    var val = $input.val(),
        $form = $input.parents('form').first();

    /* Toggle state of input */
    $input.toggleClass('filled', val.length > 0);

    /* Bubble up the filled class to style footer form properly */
    if($input.parents('p.ctct-form-field').length > 0) {
      $input.parents('p.ctct-form-field').toggleClass('filled', val.length > 0);
    }

    /* Forms with one input only need to show the submit arrow */
    if($form.hasClass('one-field-submit') || $form.hasClass('ctct-form')) {
      $form.toggleClass('filled', val.length > 0);
    }
  };

  return self;
})();

var SiteNav = ( () => {
  var self = {};

  const $nav = $("#main-nav"),
        $navlist = $("#main-nav ul"),
        $mobileToggle = $("#main-nav .expand"),
        $mobileClose = $("#main-nav .close");
  var scrollPosition = $(window).scrollTop(); ;

  self.init = () => {
    $mobileToggle.click(self.toggleMobileNav);
    $mobileClose.click(self.toggleMobileNav);

    /* Show nav if reloading or landing on scrolled-down page */
    if ( $(window).scrollTop() > 0) {
      $nav.addClass("non-initial");
    }

    window.addEventListener('resize', _.throttle(self.closeNav, 100) );
    window.addEventListener('scroll', _.throttle(self.collapseNav, 100) );

  }

  self.collapseNav = () => {
    var scroll = $(window).scrollTop();
    const iOSResistanceOffset = 60;

    if(scroll > scrollPosition && scroll > iOSResistanceOffset) {
      $nav.addClass("up-collapsed");
    } else {
      $nav.removeClass("up-collapsed");
      if(scroll > iOSResistanceOffset) {
        $nav.addClass("non-initial");
      }
      else {
        $nav.removeClass("non-initial");
      }
    }
    scrollPosition = scroll;
    self.closeNav();
  }

  self.closeNav = () => {
    if($nav.hasClass('expanded') ) {
      self.toggleMobileNav();
      $nav.removeClass("up-collapsed");
      $nav.removeClass("non-initial");
    }
  }

  self.toggleMobileNav = (e) => {
    if(e) {
      e.stopPropagation();
    }
    if( $nav.hasClass('expanded') ) {
      $navlist.fadeOut();
      $mobileClose.fadeOut();
    }
    else {
      $navlist.fadeIn();
      $mobileClose.fadeIn();
    }
    $nav.toggleClass('expanded');
    return false;
  }

  return self;
})();
